// libs
import { styled } from '@nykaa/ui-components';

// constants
import { MWEB_HEADER_HEIGHT } from 'shared/styles/base';

export const Placeholder = styled.div`
  ${({ theme }) =>
    `margin: 0 ${theme.spacing.spacing100} ${theme.spacing.spacing40} ${theme.spacing.spacing100}`};
  width: 100%;
  height: 48px;
`;

export const Header = styled.div<{ showBorder: boolean }>`
  flex-direction: column;
  display: flex;
  position: sticky;
  z-index: 5;
  top: ${MWEB_HEADER_HEIGHT - 1}px;
  ${({ theme }) => `background-color: ${theme.colors.surface}`};
  ${({ theme }) =>
    `padding: ${theme.spacing.spacing40} ${theme.spacing.spacing100} ${theme.spacing.spacing80} ${theme.spacing.spacing100}`};
  border-bottom: ${({ showBorder, theme }) =>
    showBorder ? `1px solid ${theme.colors.surface30}` : 'none'};
`;

export const Title = styled.div`
  position: relative;
`;
export const Text = styled.h1<{ totalContainerWidth: number }>`
  max-height: 48px;
  overflow: hidden;
  width: 100%;
  ${({ theme }) => theme.typography.titleMedium};
  word-break: break-word;
  margin: 0px;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const WishlistSpan = styled.span`
  position: absolute;
  right: 0px;
  top: 24px;
  height: 24px;
  ${({ theme }) => theme.typography.titleMedium};
  background-color: ${({ theme }) => theme.colors.surface};
  white-space: pre;
`;

export const ProductCount = styled.div`
  width: 100%;
  padding-top: ${({ theme }) => theme.spacing.spacing40};
  color: ${({ theme }) => theme.colors.textSecondary};
  ${({ theme }) => theme.typography.bodyMedium};
`;
